import axiosInstance from "@/api/axios";

export default {
  namespaced: true,
  state: {
    volunteers: [],
    volunteer: null,
    volunteerProfileColor: null,
    followedVolunteers: [],
    followingVolunteers: []
  },
  getters: {
    getAllVolunteers(state) {
      return state.volunteers;
    },
    getAgencyVolunteers(state) {
      return state.agencyVolunteers;
    },
    getVolunteer(state) {
      return state.volunteer;
    },
    getFollowedVolunteers(state) {
      return state.followedVolunteers;
    },
    getFollowingVolunteers(state) {
      return state.followingVolunteers;
    }
  },
  mutations: {
    setVolunteers(state, data) {
      state.volunteers = data;
    },
    setVolunteer(state, data) {
      state.volunteer = data;
    },
    setFollowedVolunteers(state, data) {
      state.followedVolunteers = data;
    },
    setFollowingVolunteers(state, data) {
      state.followingVolunteers = data;
    },
    setProfileColor(state, data) {
      state.volunteerProfileColor = data;
    },
    setVolunteerNeedDetails(state, data) {
      state.volunteerNeedDetails = data;
    },
    setAgencyVolunteers(state, data) {
      state.agencyVolunteers = data;
    },

    loadMoreVolunteers(state, data) {
      data.map(d => {
        if (state.volunteers.filter(e => e._id == d._id).length == 0) {
          state.volunteers.push(d);
        }
      });
    },
    loadMoreAgencyVolunteers(state, data) {
      data.map(d => {
        if (state.agencyVolunteers.indexOf(d) == -1)
          state.agencyVolunteers.push(d);
      });
    },
    addVolunteer(state, data) {
      const item = state.volunteers.find(item => item._id === data._id);
      if (item) {
        Object.assign(item, data);
      } else {
        state.volunteers.unshift(data);
      }
    },
    editVolunteer(state, data) {
      const item = state.volunteers.find(item => item._id === data._id);
      if (item) {
        Object.assign(item, data);
      } else {
        state.volunteers.push(data);
      }
    },
    viewVolunteer({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getUserNeedlist", params, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            console.log("API Response:", res); // Log the API response
            if (res.data.success) {
              commit("viewVolunteer", res.data.res);
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            console.log("API Error:", error); // Log any errors
            reject(error);
          });
      });
    },
    deleteVolunteer(state, data) {
      state.volunteers = state.volunteers.filter(q => q._id !== data._id);
    }
  },
  actions: {
    fetchAllVolunteers({ commit, rootState }, ageGroup) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/all", ageGroup)
          .then(res => {
            if (res.data.success == true) {
              //console.log("API Response:", res); // Log the API response
              commit("setVolunteers", res.data.res);
              resolve();
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchFollowedVolunteers({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/myFollowers", params)
          .then(res => {
            if (res.data.success == true) {
              commit("setFollowedVolunteers", res.data.followerVolunteers);
              resolve();
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchFollowingVolunteers({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/myFollowings", params)
          .then(res => {
            if (res.data.success == true) {
              commit("setFollowingVolunteers", res.data.followingVolunteers);
              resolve();
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    loadMoreVolunteers({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("volunteer/load-more", params)
          .then(res => {
            if (res.data.success == true) {
              commit("loadMoreVolunteers", res.data.res);
              resolve();
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    loadMoreAgencyVolunteers({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("volunteer/load-more-agency", params)
          .then(res => {
            if (res.data.success == true) {
              commit("loadMoreVolunteers", res.data.res);
              resolve();
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getVolunteer({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/get", params)
          .then(res => {
            if (res.data.success == true) {
              commit("setVolunteer", res.data.res);
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    editVolunteer({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/update-full", params, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.success == true) {
              commit("editVolunteer", res.data.res);
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    viewVolunteer({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getUserNeedlist", params, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            console.log("API Response:", res); // Log the API response
            if (res.data.success == true) {
              commit("viewVolunteer", res.data.res);
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            console.log("API Error:", error); // Log any errors
            reject(error);
          });
      });
    },
    deleteVolunteer({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/delete", params, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success == true) {
              commit("deleteVolunteer", params);
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    followAgency({ rootState, commit }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/follow-agency", params)
          .then(res => {
            if (res.data.success == true) {
              commit("auth/setProfile", res.data.res, { root: true });
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    followVolunteer({ rootState, commit, state }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/follow", params)
          .then(res => {
            if (res.data.success == true) {
              // Update the entire profile with the response (contains updated followed_by and followers)
              commit("auth/updateProfile", res.data.res, { root: true });
              
              // Also update the volunteer's followers array in the store for immediate UI feedback
              const volunteerId = params.user;
              const myId = rootState.auth.profile._id;
              const volunteer = state.volunteers.find(v => v._id === volunteerId);
              
              if (volunteer) {
                // Ensure followers array exists
                if (!volunteer.followers) {
                  volunteer.followers = [];
                }
                
                if (params.followed) {
                  // Following: add my ID to their followers if not already there
                  if (!volunteer.followers.includes(myId)) {
                    volunteer.followers = [...volunteer.followers, myId];
                  }
                } else {
                  // Unfollowing: remove my ID from their followers
                  volunteer.followers = volunteer.followers.filter(id => id !== myId);
                }
              }
              
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getFanned({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/fans", { _id: params })
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    sendEmailVerification({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/send-email-verification", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getWorkHours({ rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/hours", params)
          .then(res => {
            if (res.data.success == true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    copyFromProfile({ commit, rootState }) {
      commit("setVolunteer", rootState.auth.profile);
    },
    volunteerProfile({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .get("users/getAvatarColour")
          .then(res => {
            if (res.data.success == true) {
              commit("setProfileColor", res.data.data);
              resolve(res.data.data);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    VolunteerDocumentDownload({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/volunteerSummaryPdf", params)
          .then(res => {
            console.log(res);
            if (res.data.success == true) {
              commit("setVolunteerNeedDetails", res.data.data);
              resolve(res.data.data);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    VolunteerDetailedNeedView({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("need/volunteerSummary", params)
          .then(res => {
            if (res.data.success == true) {
              commit("setVolunteerNeedDetails", res.data.data);
              resolve(res.data.data);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    verifyVolunteerFromVerifiedFirst({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("users/verify-verified-first", params, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success == true) {
              commit("editVolunteer", res.data.res);
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
